import { Image, Text, View } from "@react-pdf/renderer";

import { styles } from "../../Tables";

export const TableRowDezinsekcijaKontrolaEvdListaEvidencijaHeader: React.FC<{
  datum: string;
  fullname: string;
  potpis: string;
  stanjeKontrole: string;
  opisKontrole: string;
  tackaEvidencije: string;
}> = ({
  datum,
  fullname,
  potpis,
  stanjeKontrole,
  opisKontrole,
  tackaEvidencije,
}) => (
  <View style={styles.tableRow}>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{tackaEvidencije}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{datum}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{fullname}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{potpis}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{stanjeKontrole}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{opisKontrole}</Text>
    </View>
  </View>
);

export const TableRowDezinsekcijaKontrolaEvdListaEvidencija: React.FC<{
  datum: string;
  fullname: string;
  potpis: string;
  stanjeKontrole: string;
  opisKontrole: string;
  tackaEvidencije: string;
}> = ({
  datum,
  fullname,
  potpis,
  stanjeKontrole,
  opisKontrole,
  tackaEvidencije,
}) => (
  <View style={styles.tableRow} wrap={false}>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{tackaEvidencije}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{datum}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{fullname}</Text>
    </View>
    <View style={styles.tableCol}>
      {potpis && (
        <Image style={[styles.tableCell, styles.signatureImage]} src={potpis} />
      )}
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{stanjeKontrole.toString()}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{opisKontrole}</Text>
    </View>
  </View>
);
